import React, { useState } from 'react';
import { styled } from '../../styles/stitches.config'; // Adjust this import to your stitches config file
import { Check } from 'react-bootstrap-icons';


const HiddenCheckbox = styled('input', {
    border: '0',
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px',
  });

// A container to position the checkbox correctly.
// The <label> tag allows clicking the whole area to toggle the checkbox.
const CheckboxContainer = styled('label', {
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginRight: '1rem',
    borderRadius: '8px',
    transition: 'box-shadow 150ms ease-in-out',
    border: '0.05px solid dodgerblue',
  
    variants: {
      checked: {
        true: { border: 'none' },
      },
    },
  });

// This is the actual <input> element. We hide it visually but keep it functional.


// This is our visible, styled checkbox.
// The `+` selector is key: it styles this `div` based on the state of its sibling, the HiddenCheckbox.
// In src/styles/messenger/CustomCheckbox.tsx

const StyledCheckbox = styled('div', {
    // Flexbox properties to center the checkmark
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  
    // --- Existing Styles ---
    width: '20px',
    height: '20px',
    background: '$gray4',
    border: '2px solid $gray7',
    borderRadius: '4px',
    transition: 'all 150ms',
  
    [`${HiddenCheckbox}:checked + &`]: {
      background: 'dodgerblue',
      border: 'none',
    //   borderColor: 'dodgerblue',
    },
  });

  interface CustomCheckboxProps {
    checked: boolean;
    onChange: () => void;
  }
  
  export const CustomCheckbox: React.FC<CustomCheckboxProps> = ({ checked, onChange }) => {
    // 2. Add state to track the pressed state
    const [isPressed, setIsPressed] = useState(false);
  
    return (
<CheckboxContainer
  checked={checked}
  onMouseDown={() => setIsPressed(true)}
  onMouseUp={() => setIsPressed(false)}
  onMouseLeave={() => setIsPressed(false)}
  onClick={(e) => e.stopPropagation()}
>
  <HiddenCheckbox type="checkbox" checked={checked} onChange={onChange} />
  <StyledCheckbox>
    <Check color="white" size={18} style={{ visibility: checked ? 'visible' : 'hidden' }} />
  </StyledCheckbox>
</CheckboxContainer>

    );
  };